module.exports = __webpack_public_path__ + "media/components/assets/df_logo-ab5ba09f37d4885a30f351419128e3d7.svg";